<template>
  <div>
    <loader :loading="loading"></loader>
    <div class="card custom-card">
      <div class="card-header border-bottom">
        <h3 class="card-title">Report File Manager
          <el-tooltip
            content="Upload Files"
            effect="light"
            :open-delay="300"
            placement="top">
            <base-button class="btn-link p-0" type="primary" @click="$refs.uploadfile.click()" size="sm" aria-label="Upload Files" icon>
              <i class="tim-icons icon-cloud-upload-94"></i>
              <input type="file" ref="uploadfile" @change="onUpload()" multiple="multiple" hidden>
            </base-button>
          </el-tooltip>
        </h3>
        <div class="row">
          <div class="col-md-4 form-group">
            <label>Survey Name</label>
            <el-select
              class="select-primary"
              size="large"
              placeholder="Select Survey Name"
              @change="onSurveyNameChange()"
              v-model="surveyId">
              <el-option
                class="select-primary"
                :value="nullValue"
                label="">
              </el-option>
              <el-option v-for="s in surveyNames" :key="s.hspSurveyId"
                class="select-primary"
                :value="s.hspSurveyId"
                :label="s.surveyName">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4 form-group">
            <label>Survey Instance</label>
            <el-select
              class="select-primary"
              size="large"
              placeholder="Select Survey Instance"
              @change="onSurveyUrlChange()"
              v-model="surveyUrlId">
              <el-option
                class="select-primary"
                :value="nullValue"
                label="">
              </el-option>
              <el-option v-for="s in surveyInstances" :key="s.orgSurveyId"
                class="select-primary"
                :value="s.surveyUrlId"
                :label="s.surveyUrlId">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div v-if="surveyUrlId" class="row">
          <div class="col-xl-1 col-md-6 col-sm-6 my-1">
            <div class="card m-0 p-0">
              <div class="d-flex align-items-center px-3 pt-3">
              </div>
              <div class="card-body pt-0 text-center">
                <el-tooltip
                  content="Back to Survey Name Folder"
                  effect="light"
                  :open-delay="300"
                  placement="top">
                  <div class="fa fa-ellipsis-h dirup-icon">
                    <a href="#" @click.prevent="onSurveyNameChange()">
                      <img src="img/folder-up-512.png" alt="img" class="br-7">
                    </a>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="dir in subDirs" :key="dir" class="col-xl-2 col-md-6 col-sm-6 my-1">
            <div class="card m-0 p-0">
              <div class="d-flex align-items-center px-3 pt-3">
              </div>
              <div class="card-body pt-0 text-center">
                <div class="folder-icon">
                  <a href="#" @click.prevent="onFolderClick(dir)">
                    <img src="img/folder-blue-256.jpg" alt="img" class="br-7">
                  </a>
                </div>
                <h6 class="mb-1 font-weight-semibold text-capitalize">{{ dir }}</h6>
              </div>
            </div>
          </div>
          <div v-for="file in reportFiles" :key="file.id" class="col-xl-3 col-md-6 col-sm-6 my-1">
            <div class="card m-0 p-0 border">
              <div class="d-flex align-items-center px-3 pt-3">
                <label v-if="showSelectBox" class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" name="filename-checkbox" value="option2" @click="onCheckBoxClick(file)" :checked="file.isChecked">
                  <span class="custom-control-label"></span>
                </label>
                <base-dropdown 
                  title=""
                  title-tag="a"
                  title-classes="nav-link"
                  class="fa fa-ellipsis-v float-end ms-auto nav-item">
                  <li class="nav-link">
                    <a href="#" @click.prevent="deleteFile(file)" class="nav-item dropdown-item">Delete</a>
                  </li>
                  <li v-if="hasSelection" class="nav-link">
                    <a href="#" @click.prevent="deleteSelected()" class="nav-item dropdown-item">Delete Selected</a>
                  </li>
                </base-dropdown>
              </div>
              <div class="card-body pt-0 text-center">
                <div class="file-icon">
                  <img :src="fileThumbnail(file)" alt="img" class="br-7">
                </div>
                <h6 class="mb-1 font-weight-semibold text-capitalize">{{ file.filename }}</h6>
                <span class="text-muted">{{file.sizeText}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from 'src/pages/Survey/Loader';
import BaseDropdown from '../../components/BaseDropdown.vue';
import { mapGetters } from 'vuex';
import { Select, Option } from 'element-ui';
import { getReportFiles, getDownloadFile, uploadReportFiles, deleteReportFiles } from 'src/modules/adminActions';
import swal from 'sweetalert2';
import { isNullOrEmpty } from 'src/modules/utils';

export default {
  name: 'ReportFiles',
  components: {
    Loader,
    [Option.name]: Option,
    [Select.name]: Select,
    BaseDropdown,
  },
  data() {
    return {
      loading: false,
      surveyId: null,
      surveyUrlId: null,
      surveyNames: [],
      surveyInstances: [],
      instance: null,
      subDirs: [],
      reportFiles: [],
      hasSelection: false,
      decimals: 2,
      kbPerByte: 0.0009765625,
      nullValue: null,
    };
  },
  computed: {
    hasFiles() {
      return this.reportFiles.length > 0;
    },
    showSelectBox() {
      return this.reportFiles.length > 1;
    },
    ...mapGetters(['surveys', 'getSurveyById']),
  },
  methods: {
    initialize() {
      this.initializeSurveyNames();
    },
    doNothing() {
    },
    sortObject(obj, name) {
      obj.sort((a, b) => a[name].toLowerCase().localeCompare(b[name].toLowerCase()));
    },
    fileThumbnail(file) {
      let name = file.filename.toLowerCase();
      return name.indexOf("pdf") > -1 ? "img/pdf-file.png"
        : name.indexOf("docx") > -1 || name.indexOf("doc") > -1 ? "img/word-file.png"
        : "img/generic-file.png";
    },
    resetSurveyNames() {
      this.surveyNames = [...this.surveys];
      this.sortObject(this.surveyNames, "surveyName");
    },
    resetSurveyInstances() {
      this.surveyInstances = [...this.orgSurveys];
      this.sortObject(this.surveyInstances, "surveyUrlId");
    },
    initializeSurveyNames() {
      this.resetSurveyNames();
    },
    updateSurveyInstances(surveyId) {
      if (isNullOrEmpty(surveyId)) {
        return;
      }
      this.surveyInstances = this.surveyNames.find(x => x.hspSurveyId === surveyId).orgSurveys;
    },
    onSurveyNameChange() {
      this.surveyUrlId = null;
      this.updateSurveyInstances(this.surveyId);
      this.getFiles();
    },
    onSurveyUrlChange() {
      this.getFiles();
    },
    onFolderClick(folder) {
      this.surveyUrlId = folder;
      this.getFiles();
    },
    getFiles(reportRequest) {
      reportRequest = reportRequest || {
        surveyUrlId: this.surveyUrlId,
        hspSurveyId: this.surveyId,
        isManaging: true,
      };

      this.loading = true;
      getReportFiles(reportRequest)
        .then(response => {
          this.hasSelection = false;
          this.subDirs = response.data.subDirectories;
          this.reportFiles = response.data.fileList;
          this.reportFiles.forEach(x => {
            x.isChecked = false;
            x.filePath = "/reports/" + x.parentDirectory + "/" + x.filename;
            x.sizeText = this.toFileSizeText(x.size);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toFileSizeText(size) {
      let description = " Bytes";
      let sizeNum = size;
      if (sizeNum >= 1.024e9) {
        description = " GB";
        sizeNum *= 1e-6 * this.kbPerByte;
      }
      else if (sizeNum >= 1.024e6) {
        description = " MB";
        sizeNum *= 1e-3 * this.kbPerByte;
      }
      else if (sizeNum >= 1024) {
        description = " KB";
        sizeNum *= this.kbPerByte;
      }

      return sizeNum.toFixed(this.decimals) + description;
    },
    addFiles(files) {
      let ids = this.reportFiles.map(x => x.id);
      let maxId = Math.max(...ids);
      let count = 0;
      files.forEach(x => {
        let exist = this.reportFiles.find(y => y.filename === x.filename && y.size === x.size);
        let indexOf = -1;
        if (exist) {
          indexOf = this.reportFiles.indexOf(exist);
        }

        count++;
        let newItem = {
          ...x,
          ...{ id: maxId + count, isChecked: false, sizeText: this.toFileSizeText(x.size), filePath: `/reports/${x.parentDirectory}/${x.filename}` }
        };
        if (indexOf > -1) {
          this.reportFiles.splice(indexOf, 1, newItem);
        }
        else {
          this.reportFiles.push(newItem);
        }
      });
    },
    removeFromFileList(files) {
      this.reportFiles = this.reportFiles.filter(x => files.indexOf(x.filename) == -1);
    },
    async deleteFiles(files) {
      if (isNullOrEmpty(files)) {
        return;
      }

      deleteReportFiles({
        surveyUrlId: this.surveyUrlId,
        hspSurveyId: this.surveyId,
        files: files.map(x => x.filename),
      })
      .then(response => {
        let result = response.data;
        let errorMessage = '';

        if(result.errors && result.errors.length) {
          result.errors.forEach(error => {
            errorMessage += `${error}<br>`
          });
          swal('Report File Delete Error', errorMessage, 'error');
        }

        if (result.success && !isNullOrEmpty(result.filesDeleted)) {
          this.removeFromFileList(result.filesDeleted);

          let title = "Deleted Report File";
          let msg = "";
          if (result.filesDeleted.length === 1) {
            msg = `${result.filesDeleted[0]}`;
          }
          else {
            title += "s";
            msg += '<div class="text-left"><ul>';
            for (let f of result.filesDeleted) {
              msg += `<li>${f}</li>`;
            }
            msg += '</ul></div>';
            }
          swal.fire({
            title: title, 
            html: msg, 
            icon: 'success',
            type: 'info'
          });
        }
      })
      .catch(error => {
        swal("Report File Delete Error Caught", error, "error");
      });
    },
    async deleteFile(fileInfo) {
      await this.deleteFiles([fileInfo]);
    },
    async deleteSelected() {
      const selected = this.reportFiles.filter(x => x.isChecked);
      if (selected.length === 0) {
        return;
      }

      await this.deleteFiles(selected);
    },
    onCheckBoxClick(fileInfo) {
      let found = this.reportFiles.find(x => x.id === fileInfo.id);
      if (!found) {
        return;
      }

      found.isChecked = !found.isChecked;
      this.hasSelection = this.reportFiles.filter(x => x.isChecked).length > 0;
    },
    onUpload() {
      let files = this.$refs.uploadfile.files;
      if (files.length === 0) {
        return;
      }

      if (isNullOrEmpty(this.surveyId)) {
        swal("Report File Upload", "Survey Name is required", "error");
        return;
      }

      const formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append('files[' + i + ']', file);
      }

      uploadReportFiles({ hspSurveyId: this.surveyId, surveyUrlId: this.surveyUrlId, formData: formData })
      .then(response => {
        let result = response.data;
        let errorMessage = '';
        let msgTitle = "Report File Upload";
        let msgType = "info";

        if (result.errors && result.errors.length) {
          msgTitle += " Error";
          msgType = "error";
          errorMessage = "Errors:<ul>";
          result.errors.forEach(error => {
            errorMessage += `<li>${error}</li>`
          });
          errorMessage += "</ul>";
        }

        if (!isNullOrEmpty(result.fileExists)) {
          errorMessage += `The following files aready exist:<ul>`;
          result.fileExists.forEach(x => {
            errorMessage += `<li>${x}</li>`;
          });
          errorMessage += "</ul>If updating the file, please delete then re-add.";
        }

        if (!isNullOrEmpty(errorMessage)) {
          swal(msgTitle, `<div class="text-left">${errorMessage}</div>`, msgType);
        }

        if (result.success) {
          if (!isNullOrEmpty(result.filesAdded)) {
            this.addFiles(result.filesAdded);
          }
        }
      })
      .catch(error => {
        swal("Report File Upload Error Caught", error, "error");
      });
    },
  },
  created() {
    this.initialize();
  },
};
</script>

<style scoped>
.float-end {
  float: right !important;
}

.ms-auto {
  margin-left: auto !important;
}

.file-icon img {
  height: 86px;
  width: 70px;
}

.folder-icon img {
  height: 70px;
  width: 70px;
}

.dirup-icon img {
  height: 30px;
  width: 30px;
}

.br-7 {
  border-radius: 7px;
}
</style>